import './index.css'
import React from 'react'

const Author = (props) => {
    let BOOK = 0;
    const currentBookID = props.currentBookID;
    for (let i = 0; i < props.payload.listData.length; i++) {
        const element = props.payload.listData[i];
        if (element.bookId === currentBookID) {
          BOOK = i;
        }
    }
    const ITEM = props.payload.listData[BOOK];

    return (
        <div className="relative">
          <div className={`author_image_wrapper bg-pallet-7`}>
              <div className={`author_image_bg_patter`}>
                <div className="w-full max-w-md mx-auto shadow-lg">
                  <img src={ITEM.bookAuthorPhoto} className={`w-full max-w-md h-75`} alt={ITEM.bookAuthor} />
                </div>
              </div>
          </div>

            <div className={`author_content w-full max-w-md mx-auto flex flex-col justify-center items-center shadow-lg pb-56`}>
                <p className="autor_title font-bold">{ITEM.bookAuthorGender === 'M' ? 'O Autor' : 'A Autora'}</p>
                <p className={"author_biography"}>{ITEM.bookAuthorBiography}</p>
            </div>

            <div className={"review_details absolute bottom-0 left-0"} />
        </div>
    )
}

export default Author